import axios from "../utils/axios-interceptor";
import chunkData from "../mock-data/chunk-data.json";
import convertData from "../mock-data/convert.json";
import iterationData from "../mock-data/iteration.json";
import apiCheck from "../mock-data/apiCheck.json";

export const convertCodeApi = async(payload) => {
  try {
    if(window.isMockData){
      console.log("Mock API called ---> Convert");
      const data = convertData;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const form = new FormData();
      for (let i = 0; i < payload.source_files.length; i++) {
        form.append("source_files", payload.source_files[i])
      }
      form.append("selected_model", payload.model)
      form.append("user_prompt", payload.user_prompt)
      const encodedParamTarget = encodeURIComponent(payload.target_language);
      const encodedParamSource = encodeURIComponent(payload.source_language);
      const res = await axios.post(`/convert?source_language=${encodedParamSource}&target_language=${encodedParamTarget}&tdd_required=${payload.tdd_required}&user=${payload.user}`,
        form, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });
      const data = await res.data
      return data
    }
    
  } catch (error) {
    throw new Error(error.message)
  }
}

export const githubLinkApi = async(payload) => {
  try {
    const res = await axios.post(`/github_link_api?repo_url=${payload.repoPath}&language=${payload.language}`, payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const iterationApi = async(payload) => {
  try {
    if(window.isMockData){
      console.log("Mock API called ---> Iteration");
      const data = iterationData;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const res = await axios.post("/iterative-improvement", payload);
      const data = await res.data
      return data
    }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const bteqCodeSummaryApi = async(payload) => {
  try {
    if(window.isMockData){
      console.log("Mock API called ---> BTEQ Summary");
      const data = apiCheck;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const form = new FormData();
      for (let i = 0; i < payload.source_files.length; i++) {
        form.append("files", payload.source_files[i])
      }
      const res = await axios.post(`/uploadbteqfile/?iteration_count=${payload.iteration}`,
        form, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });
      const data = await res.data;
      return data;
    }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const bteqCodeConversionChunkApi = async(payload) => {
  try {
    if(window.isMockData){
      console.log("Mock API called ---> Chunking");
      const data = chunkData;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const form = new FormData();
      for (let i = 0; i < payload.source_files.length; i++) {
        form.append("files", payload.source_files[i])
      }
      form.append("source_language", payload.source_language);
      form.append("target_language", payload.target_language);
      form.append("iteration_count", payload.iteration_count);
      form.append("selected_model", payload.selected_model);
      form.append("user_prompt", payload.user_prompt);
      form.append("user", payload.username);
      const res = await axios.post("/process-multiple-bteq-files", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      const data = await res.data;
      return data;
    }
    
  } catch (error) {
    throw new Error(error.message)
  }
}